import React, {Component, Fragment} from "react";
import {Card, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ToastHelper from "../../../utils/ToastHelper";
import BeneficiaryService from "../../../services/Beneficiary/BeneficiaryService";
import BeneficiaryCard from "../../../components/Beneficiaries/BeneficiaryCard";
import BeneficiaryExistingCard from "../../../components/Beneficiaries/BeneficiaryExistingCard";
import SFXLoadingComponent from "../../../components/SFXLoadingComponent";
import BeneficiaryEdit from "./BeneficiaryEdit";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import {Link, withRouter} from "react-router-dom";
import ButtonAddNewComponent from "../../../components/ButtonAddNewComponent";

const BENEFICIARY_VIEW = "beneficiary view";
const BENEFICIARY_EDIT = "beneficiary edit";

class Beneficiaries extends Component {
    constructor(props) {
        super(props);

        this.registrationId = this.props.customer.registrationId;

        this.state = {
            currentTab: BENEFICIARY_VIEW,
            beneficiary: null,
            beneficiaries: [],
            registrationId: '',
            loading: true,

            showDeleteModal: false,

            pageSize: 10,
            showLoadMore: true
        };
    }

    componentDidMount() {
        this.loadData();
        this.props.setSelectedScreen("Beneficiaries");
    }

    loadData() {
        this.props.setHeader("Beneficiaries");
        BeneficiaryService.retrieveBeneficiariesByRegistrationId(this.props.customer.registrationId, "", this.state.pageSize).then(response => {
            let totalRecords = response.headers.get("X-Total-Records");
            if (response.body) {
                this.setState({
                    beneficiaries: response.body,
                    loading: false,
                    showLoadMore: totalRecords > response.body.length
                });
            } else {
                ToastHelper.formatError(response);
            }
        });
    }

    editBeneficiary = beneficiary => {

        this.setState({
            currentTab: BENEFICIARY_EDIT,
            beneficiary: beneficiary
        })
    };

    showDeleteBeneficiaryModal = beneficiary => {

        this.setState({
            showDeleteModal: true,
            beneficiary: beneficiary
        })
    };

    deleteBeneficiary(beneficiary) {

        BeneficiaryService.deleteBeneficiary(beneficiary.id).then(response => {
            this.setState({
                showDeleteModal: false
            }, () => this.loadData())
        })
    }

    viewBeneficiary() {

        this.setState({
            currentTab: BENEFICIARY_VIEW
        }, () => this.loadData())

    }

    sendMoneyToBeneficiary(beneficiary) {
        this.props.history.push("/create-beneficiary-transaction/" + beneficiary.id);
    }

    render() {

        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }

        return <Fragment>
            {this.props.isMobile ? this.renderContent("mobile") : this.renderContent("browser")}
        </Fragment>

    }

    renderContent(className) {

        return <Fragment>

            {this.state.currentTab === BENEFICIARY_VIEW && (className === 'mobile' ? this.renderMobileBeneficiariesView(className) : this.renderBrowserBeneficiariesView(className))}
            {this.state.currentTab === BENEFICIARY_EDIT && this.renderBeneficiariesEdit(className)}

        </Fragment>

    }

    renderBeneficiariesView(className) {

        return <Fragment>

            {this.state.showDeleteModal && this.renderDeleteBeneficiaryModal(className)}

            {this.state.beneficiaries.length === 0 ?
                <div style={{height: "80%", textAlign: "center"}}>
                    <br />
                    You have no beneficiaries.
                    <br />
                    Click below to create a beneficiary and start sending money now
                    <br />
                    <br />
                    <Link to={"/create-beneficiary"}>
                        <SFXButtonComponent className={"browser_orange_oval_button"}>
                            Create Beneficiary
                        </SFXButtonComponent>
                    </Link>
                </div>
                :
                <Fragment>
                    {this.state.beneficiaries.map((beneficiary, index) => {
                        return <Fragment key={index}>
                            {!this.props.existingBeneficiary ?
                                <BeneficiaryCard
                                    beneficiary={beneficiary}
                                    onEditClick={this.editBeneficiary.bind(this)}
                                    onDeleteClick={this.showDeleteBeneficiaryModal.bind(this)}
                                    onSendMoneyClick={this.sendMoneyToBeneficiary.bind(this)}
                                />
                                :
                                <BeneficiaryExistingCard
                                    beneficiary={beneficiary}
                                    transactAllowed={true}
                                />
                            }
                        </Fragment>
                    })}
                </Fragment>
            }

            {this.state.showLoadMore &&
            <div
                style={{margin: "auto", marginBottom: "15px", textAlign: "center"}}
            >
                <SFXButtonComponent
                    className={className + "_orange_oval_button"}
                    onClick={() => this.setState({
                        pageSize: this.state.pageSize + 10
                    }, () => this.loadData())}
                >
                    Load More
                </SFXButtonComponent>
            </div>
            }
            {!this.props.existingBeneficiary &&
            <ButtonAddNewComponent
                className={className}
                link={"/create-beneficiary"}
            />
            }
        </Fragment>
    }

    renderMobileBeneficiariesView(className) {

        return <div style={{
            width: "100%",
            height: "95%",
            overflowY: "scroll",
            overflowX: "hidden",
            padding: "10px",
            backgroundColor: "rgb(240, 240, 240)",
            margin: "auto"
        }}>
            {this.renderBeneficiariesView(className)}
        </div>
    }

    renderBrowserBeneficiariesView(className) {

        return <Card style={{
            padding: "15px",
            height: "75%",
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "85%",
            margin: "auto"
        }}>
            <div style={{
                overflowY: "scroll",
                overflowX: "hidden"
            }}
                 className={"browser-card"}
            >
                {this.renderBeneficiariesView(className)}
            </div>
        </Card>
    }

    renderBeneficiariesEdit(className) {

        return <Fragment>
            <br/>
            <BeneficiaryEdit
                registrationId={this.registrationId}
                className={className}
                beneficiary={this.state.beneficiary}
                goBack={this.viewBeneficiary.bind(this)}
                setHeader={() => this.props.setHeader("Update Beneficiary")}
            />

        </Fragment>

    }

    renderDeleteBeneficiaryModal(className) {

        return <Modal isOpen={this.state.showDeleteModal}>

            <ModalHeader
                className={className + "_modal_header"}>Delete {this.state.beneficiary["beneficiaryName"]}</ModalHeader>
            <ModalBody>Are you sure you want to delete this beneficiary?</ModalBody>
            <ModalFooter>
                <SFXButtonComponent
                    onClick={() => this.deleteBeneficiary(this.state.beneficiary)}
                >Delete</SFXButtonComponent>
                <SFXButtonComponent
                    onClick={() => this.setState({
                        showDeleteModal: false
                    })}
                >Close</SFXButtonComponent>
            </ModalFooter>

        </Modal>

    }
}

export default withRouter(Beneficiaries);